const simpleTabNavigation = {
    init() {
        const navigations = document.querySelectorAll('.js-simple-tab-navigation');

        navigations.forEach((navigation) => {
            const params = new URLSearchParams(window.location.search);
            let {tabName} = navigation.dataset;
            let elementId = navigation.id;
            const reloadPage = navigation.dataset.tabReloadPage;
            const buttons = navigation.querySelectorAll(`.js-simple-tab-button[data-tab-id="${tabName}"]`);
            const tabs = navigation.querySelectorAll('.js-simple-tab');

            const navigationsWithSameName = Array.from(navigations).filter((item) => item.dataset.tabName === tabName);
            const navigationsWithSameId = Array.from(navigations).filter((item) => item.id === elementId);

            const hasTabNameDuplicates = navigationsWithSameName.length > 1;
            const hasIdDuplicates = navigationsWithSameId.length > 1;

            if (!tabs.length) return;

            const fixButtonHrefs = (element) => {
                const fixedName = element.dataset.tabName;
                const buttons = navigation.querySelectorAll(`.js-simple-tab-button[data-tab-id="${tabName}"]`);

                buttons.forEach((item) => {
                    const itemRef = item;
                    itemRef.href = `?${fixedName}=${itemRef.dataset.tabIndex}${reloadPage ? `#${element.id}` : ''}`;
                });
            };

            // check for duplicated tab names
            if (hasTabNameDuplicates) {
                navigationsWithSameName.forEach((item, index) => {
                    const itemRef = item;
                    const oldTabName = itemRef.dataset.tabName;
                    const newTabName = `${oldTabName}-${index + 1}`;
                    itemRef.dataset.tabName = newTabName;

                    // Update data-tab-id on all buttons within this navigation
                    const buttonsToUpdate = itemRef.querySelectorAll(`.js-simple-tab-button[data-tab-id="${oldTabName}"]`);
                    buttonsToUpdate.forEach((btn) => {
                        btn.dataset.tabId = newTabName;
                    });

                    fixButtonHrefs(itemRef);
                });
                tabName = navigation.dataset.tabName;
            }

            // check for duplicated tab ids
            if (hasIdDuplicates) {
                navigationsWithSameId.forEach((item, index) => {
                    const itemRef = item;
                    itemRef.id += `-${index + 1}`;
                    fixButtonHrefs(itemRef);
                });
                elementId = navigation.id;
            }

            const setCurrentIndex = (index, changeHash) => {
                const url = new URL(window.location);

                params.set(tabName, index);
                currentIndex = index;

                findCurrentButtonAndSetActive();
                findCurrentTabAndSetActive();

                if (changeHash) {
                    url.hash = elementId;
                }
                url.searchParams.set(tabName, index);
                window.history.pushState(null, '', url.toString());
            };

            const findCurrentTabAndSetActive = () => {
                tabs.forEach((element) => {
                    if (element.dataset.tabIndex === currentIndex) {
                        element.classList.add('active');
                    } else {
                        element.classList.remove('active');
                    }
                });
            };

            const findCurrentButtonAndSetActive = () => {
                buttons.forEach((element) => {
                    if (element.dataset.tabIndex === currentIndex) {
                        element.classList.add('active');
                    } else {
                        element.classList.remove('active');
                    }
                });
            };

            if (!reloadPage) {
                buttons.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        setCurrentIndex(button.dataset.tabIndex, true);
                    });
                });
            }

            let currentIndex = params.get(tabName);

            if (!currentIndex) {
                setCurrentIndex(buttons[0] ? buttons[0].dataset.tabIndex : tabs[0].dataset.tabIndex);
            }

            try {
                findCurrentButtonAndSetActive();
            } catch {
                // tab bar is hidden
            }

            findCurrentTabAndSetActive();
        });
    },
};

export default simpleTabNavigation;
